(() => {
  const roots = [...document.querySelectorAll('[data-nubs-header-account]')];
  if (!roots.length) return;

  const readJson = (response) => response.json().catch(() => null);
  const ADMIN_CACHE_KEY = 'nubs-header-admin-state-v1';
  const BADGE_CACHE_KEY = 'nubs-header-badge-state-v1';
  const BADGE_CACHE_TTL_MS = 30 * 1000;


  function readBadgeCache() {
    try {
      const parsed = JSON.parse(sessionStorage.getItem(BADGE_CACHE_KEY) || 'null');
      if (!parsed || !Number.isFinite(Number(parsed.cachedAt))) return null;
      if (Date.now() - Number(parsed.cachedAt) > BADGE_CACHE_TTL_MS) return null;
      return parsed;
    } catch (_) {
      return null;
    }
  }

  function writeBadgeCache(value) {
    try {
      if (!value) { sessionStorage.removeItem(BADGE_CACHE_KEY); return; }
      sessionStorage.setItem(BADGE_CACHE_KEY, JSON.stringify({...value, cachedAt: Date.now()}));
    } catch (_) {}
  }

  function paintBadgeState(root, state) {
    if (!state) return false;
    setBadge(root.querySelector('[data-header-messages-badge]'), Math.max(0, Number(state.unread) || 0));
    const admin = root.querySelector('[data-header-admin]');
    if (!admin) return true;
    const isAdmin = state.isAdmin === true;
    admin.hidden = !isAdmin;
    if (!isAdmin) {
      admin.classList.remove('has-review-work','has-reports');
      setBadge(root.querySelector('[data-header-admin-badge]'), 0);
      return true;
    }
    const correctionCount = Math.max(0, Number(state.correctionCount) || 0);
    const entryCount = Math.max(0, Number(state.entryCount) || 0);
    const reportCount = Math.max(0, Number(state.reportCount) || 0);
    admin.classList.toggle('has-review-work', reportCount < 1 && (correctionCount + entryCount) > 0);
    admin.classList.toggle('has-reports', reportCount > 0);
    setBadge(root.querySelector('[data-header-admin-badge]'), correctionCount + entryCount + reportCount);
    const c = root.querySelector('[data-header-admin-corrections]'); if (c) c.textContent = correctionCount ? String(correctionCount) : '';
    const e = root.querySelector('[data-header-admin-entries]'); if (e) e.textContent = entryCount ? String(entryCount) : '';
    const r = root.querySelector('[data-header-admin-reports]'); if (r) r.textContent = reportCount ? String(reportCount) : '';
    return true;
  }

  function readAdminCache() {
    try {
      const parsed = JSON.parse(sessionStorage.getItem(ADMIN_CACHE_KEY) || 'null');
      if (!parsed || parsed.isAdmin !== true || Date.now()-Number(parsed.cachedAt||0)>120000) return null;
      return parsed;
    } catch (_) {
      return null;
    }
  }

  function writeAdminCache(value) {
    try {
      if (!value?.isAdmin) { sessionStorage.removeItem(ADMIN_CACHE_KEY); return; }
      sessionStorage.setItem(ADMIN_CACHE_KEY, JSON.stringify(value));
    } catch (_) {}
  }

  function paintCachedAdmin(root) {
    const cached = readAdminCache();
    if (!cached) return;
    const admin = root.querySelector('[data-header-admin]');
    if (!admin) return;
    admin.hidden = false;
    const correctionCount = Math.max(0, Number(cached.correctionCount) || 0);
    const entryCount = Math.max(0, Number(cached.entryCount) || 0);
    const reportCount = Math.max(0, Number(cached.reportCount) || 0);
    admin.classList.toggle('has-review-work', reportCount < 1 && (correctionCount + entryCount) > 0);
    admin.classList.toggle('has-reports', reportCount > 0);
    setBadge(root.querySelector('[data-header-admin-badge]'), correctionCount + entryCount + reportCount);
    const c = root.querySelector('[data-header-admin-corrections]'); if (c) c.textContent = correctionCount ? String(correctionCount) : '';
    const e = root.querySelector('[data-header-admin-entries]'); if (e) e.textContent = entryCount ? String(entryCount) : '';
    const r = root.querySelector('[data-header-admin-reports]'); if (r) r.textContent = reportCount ? String(reportCount) : '';
  }

  function bridge(root) {
    return String(root.dataset.bridgeUrl || '').trim().replace(/\/+$/, '');
  }

  function loginUrl(root) {
    const base = bridge(root);
    const target = `${location.pathname}${location.search}${location.hash}`;
    const storefrontReturn = `/bridge/storefront-return?to=${encodeURIComponent(target)}`;
    return `${base}/account/login?return_to=${encodeURIComponent(storefrontReturn)}`;
  }

  function refreshSignInHref(root) {
    const signin = root.querySelector('[data-header-account-signin]');
    if (signin) signin.href = loginUrl(root);
  }

  function close(root) {
    const menu = root.querySelector('[data-header-account-menu]');
    const trigger = root.querySelector('[data-header-account-trigger]');
    if (menu) menu.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
  }

  function paint(root, profileState) {
    const signin = root.querySelector('[data-header-account-signin]');
    const signedIn = root.querySelector('[data-header-account-signed-in]');
    const username = root.querySelector('[data-header-account-username]');

    if (signin) signin.href = loginUrl(root);

    if (profileState?.authenticated) {
      window.NubsSessionState?.writeAuthPresentation?.('signed-in');
      if (signin) signin.hidden = true;
      if (signedIn) signedIn.hidden = false;
      if (username) {
        const displayName = String(profileState.profile?.username || 'Account');
        username.textContent = displayName;
        username.title = displayName;
      }
      document.documentElement.dataset.nubsAccountAuth = 'signed-in';
      document.dispatchEvent(new CustomEvent('nubs:header-account-state', {detail:{authenticated:true}}));
      const cachedBadges = readBadgeCache();
      if (cachedBadges) paintBadgeState(root, cachedBadges);
      else paintCachedAdmin(root);
      refreshBadges(root);
      return;
    }

    // Null/unknown is not the same thing as signed out. Keep both controls hidden
    // until Hydrogen has actually answered, preventing auth UI flashes.
    if (!profileState || typeof profileState.authenticated !== 'boolean') {
      if (signin) signin.hidden = true;
      if (signedIn) signedIn.hidden = true;
      document.documentElement.dataset.nubsAccountAuth = 'unknown';
      return;
    }

    if (signin) signin.hidden = false;
    if (signedIn) signedIn.hidden = true;
    if (username) { username.textContent='Account'; username.removeAttribute('title'); }
    document.documentElement.dataset.nubsAccountAuth = 'signed-out';
    document.dispatchEvent(new CustomEvent('nubs:header-account-state', {detail:{authenticated:false}}));
    clearBadges(root);
    close(root);
  }


  function setBadge(node, value) {
    if (!node) return;
    const count = Math.max(0, Number(value) || 0);
    node.textContent = count > 99 ? '99+' : String(count);
    node.hidden = count < 1;
  }

  function clearBadges(root) {
    writeAdminCache(null);
    writeBadgeCache(null);
    setBadge(root.querySelector('[data-header-messages-badge]'), 0);
    setBadge(root.querySelector('[data-header-admin-badge]'), 0);
    const admin = root.querySelector('[data-header-admin]');
    if (admin) { admin.hidden = true; admin.classList.remove('has-review-work','has-reports'); }
  }

  let badgeRefreshPromise = null;
  let badgeGeneration = 0;
  document.addEventListener('nubs:session-cleared',()=>{badgeGeneration++;badgeRefreshPromise=null;writeBadgeCache(null);writeAdminCache(null);});
  async function refreshBadges(root, {force = false} = {}) {
    const base = bridge(root);
    if (!base) return null;
    if (!force) {
      const cached = readBadgeCache();
      if (cached) {
        paintBadgeState(root, cached);
        return cached;
      }
    }
    if (badgeRefreshPromise) return badgeRefreshPromise;

    const epoch = badgeGeneration;
    badgeRefreshPromise = (async () => {
      const response = await fetch(`${base}/bridge/badges`,{credentials:'include',cache:'no-store',headers:{Accept:'application/json'}});
      const payload = await readJson(response);
      if (epoch !== badgeGeneration) return null;
      if (!response.ok || !payload?.ok) return null;
      const state={unread:payload.unread,isAdmin:payload.isAdmin===true,correctionCount:payload.correctionCount,entryCount:payload.entryCount,reportCount:payload.reportCount};
      writeBadgeCache(state);
      if(state.isAdmin)writeAdminCache({...state,cachedAt:Date.now()});else writeAdminCache(null);
      roots.forEach(item=>paintBadgeState(item,state));
      return state;
    })().catch(()=>null).finally(() => { if(epoch===badgeGeneration)badgeRefreshPromise=null; });
    return badgeRefreshPromise;
  }

  async function signOut(root, button) {
    window.NubsSessionState?.clearAuthPresentation?.();
    const base = bridge(root);
    if (!base || button?.dataset.busy === '1') return;
    if (button) {
      button.dataset.busy = '1';
      button.disabled = true;
      button.textContent = 'Signing out…';
    }

    try {
      const tokenResponse = await fetch(`${base}/bridge/csrf`, {
        credentials: 'include',
        cache: 'no-store',
        headers: {'Accept': 'application/json'},
      });
      const tokenPayload = await readJson(tokenResponse);
      if (tokenResponse.status === 401) {
        window.NubsSessionState?.clearAll?.();
        location.assign('/');
        return;
      }
      if (!tokenResponse.ok || !tokenPayload?.csrfToken) throw new Error('Unable to prepare sign out.');

      const response = await fetch(`${base}/bridge/logout-start`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Accept':'application/json','Content-Type':'text/plain;charset=UTF-8'},
        body: JSON.stringify({csrfToken: tokenPayload.csrfToken}),
      });
      const payload = await readJson(response);
      if (response.status === 401) {
        window.NubsSessionState?.clearAll?.();
        location.assign('/');
        return;
      }
      if (!response.ok || !payload?.ok || !payload.logoutUrl) throw new Error(payload?.error || 'Unable to sign out.');
      window.NubsSessionState?.clearAll?.();
      location.assign(String(payload.logoutUrl));
    } catch (error) {
      console.error('[Nub\'s Media] Header sign out failed:', error);
      if (button) {
        button.dataset.busy = '';
        button.disabled = false;
        button.textContent = 'Sign out';
      }
    }
  }

  roots.forEach((root) => {
    paint(root, window.NubsSessionState?.readProfile?.());

    const trigger = root.querySelector('[data-header-account-trigger]');
    const menu = root.querySelector('[data-header-account-menu]');
    const signinLink = root.querySelector('[data-header-account-signin]');
    refreshSignInHref(root);
    signinLink?.addEventListener('pointerdown', () => {
      window.NubsSessionState?.clearAuthPresentation?.();
      refreshSignInHref(root);
    }, {passive:true});
    signinLink?.addEventListener('focus', () => refreshSignInHref(root));
    // The header survives soft navigation and browser history restoration. An
    // open account menu must not remain visible on the previous/next page.
    const handleNavigation = () => {
      close(root);
      refreshSignInHref(root);
    };
    document.addEventListener('nubs:pagechange', handleNavigation);
    window.addEventListener('popstate', handleNavigation);
    window.addEventListener('hashchange', handleNavigation);
    window.addEventListener('pageshow', handleNavigation);
    trigger?.addEventListener('click', () => {
      const opening = Boolean(menu?.hidden);
      if (menu) menu.hidden = !opening;
      trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });

    root.querySelector('[data-header-account-signout]')?.addEventListener('click', (event) => {
      event.preventDefault();
      signOut(root, event.currentTarget);
    });

    menu?.addEventListener('click', (event) => {
      const menuItem = event.target instanceof Element ? event.target.closest('[role="menuitem"]') : null;
      if (menuItem && menu.contains(menuItem)) close(root);
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) close(root);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close(root);
    });

    document.addEventListener('nubs:profile-state', (event) => paint(root, event.detail));
    window.NubsSessionState?.fetchProfile?.().then((state) => paint(root, state)).catch(() => {});
  });
})();
